<template>
  <v-card>
    <v-card-title class="headline font-weight-thin">Delete Confirmation</v-card-title>
    <v-card-text>
      Are you sure you want to delete pack
      <span class="font-weight-bold">{{ pack.title }}</span
      >?
    </v-card-text>
    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
      <v-btn @click="cancel" class="mr-2" outlined>Cancel</v-btn>
      <v-btn class="elevation-0 font-weight-bold" color="red" data-cy="confirmDelete" @click="submit" outlined
        >Delete</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  methods: {
    cancel() {
      this.$emit("setDialog", false);
    },
    async submit() {
      const { id, title } = this.pack;

      try {
        await this.delete({ id });
        this.$emit("setDialog", false);
        this.$notifySuccess({ message: `Successfully deleted ${title}` });
      } catch (e) {
        this.$notifyError({
          message: `Could not delete pack.`,
        });
      }
    },
    ...mapActions({
      delete: "pack/remove",
    }),
  },
  props: { pack: { required: true, type: Object } },
};
</script>
